export default {
  testing: 'Testing',
  ready: 'Ready',
  deployed: 'Deployed',
  obsolete: 'Obsolete'
}
